import React from 'react';
import {Link} from 'react-router-dom';
import bannerBg from '../assets/AirDuctCleaning.webp';

const PageLayout = ({pageTitle, desc}) =>{
    return(
        <>
            <div
                className="dz-bnr-inr style-1 text-center"
                style={{
                    backgroundImage: `linear-gradient(rgba(21, 58, 94, 0.82), rgba(21, 58, 94, 0.82)), url(${bannerBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div className="container">
                    <div className="dz-bnr-inr-entry">
                        <h1>{pageTitle}</h1>
                        {desc !== false  &&   
                            <p className="text" style={{ color: '#fff' }}>{desc}</p>                            
                        }
                        <nav  className="breadcrumb-row">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                                <li className="breadcrumb-item active">{pageTitle}</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    )
}
export default PageLayout;